import { Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { TemplateLayoutHelper } from '@fi-app/template/template-layout-helper';
import { BaseItemModelService } from '@fi-app/template/base-item.model';

@Component({
    selector: 'fi-document-item-view',
    templateUrl: './item-view.component.html',
    standalone: false,
})
export class DocumentItemViewComponent implements OnInit {
    @Input() item: BaseItemModelService;
    @Input() disableEdit: boolean = false;
    @Input() compareWith?: DocumentItemViewComponent;
    @Input() languageId: number;
    @Input() templateLayoutHelper: TemplateLayoutHelper;

    @ViewChild('container', { read: ViewContainerRef, static: false }) container: ViewContainerRef;
    @Output() onItemColumnClick: EventEmitter<any> = new EventEmitter();
    @Output() contentChange = new EventEmitter();
    @Output() afterRender = new EventEmitter();

    ngOnInit(): void {}

    itemColumnClick(column) {
        this.onItemColumnClick.emit({
            item: this.item,
            column: column,
        });
    }

    onContentChange($event) {
        this.contentChange.emit($event);
    }

    onAfterViewInit() {
        this.afterRender.emit();
    }
}
